import { ResponsiveCompactRendererComponent } from "@valg-shared/components/table/renderers/compact-renderer/responsive-compact-renderer.component";
import { BarChartRendererComponent } from "../table/renderers/bar-chart-renderer/bar-chart-renderer.component";
import { ResponsiveBarChartRendererComponent } from "../table/renderers/responsive-bar-chart-renderer/responsive-bar-chart-renderer.component";
import { ColumnMetadata, ResponsiveRendererType } from "@valg-shared/components/table/table/column-metadata";
import { WithPropsOfType } from "@valg-shared/forms";
import { TableDataItem } from "@valg-shared/components/table/table/table.component";
import { ListOrganisation } from "@shared/clients/api.generated";

export const PartyColumnDef: WithPropsOfType<PartyOrCandidateListBase, ColumnMetadata> = {

  title: {
    title: 'parties_table.title',
    path: "title",
    childPath: "name",
    class: 'w-60-expansion w-xl-30',
    presentationComponent: ResponsiveBarChartRendererComponent,
    responsiveRenderer: {
      path: "percentage",
      breakpoint: "xl"
    },
  },
  votes: {
    title: 'parties_table.votes',
    class: 'w-20 w-xl-15 no-wrap',
    presentationComponent: ResponsiveCompactRendererComponent,
    responsiveRenderer: {
      breakpoint: 'xl',
      path: 'percentage',
      type: ResponsiveRendererType.Percentage
    },
    rightAligned: false
  },
  diff: {
    title: 'parties_table.diff',
    class: "w-20 w-xl-15 no-wrap",
    presentationComponent: ResponsiveCompactRendererComponent,
    rendererOptions: new Map().set('showColors', true),
    responsiveRenderer: {
      breakpoint: 'xl',
      path: 'percentage_diff',
      type: ResponsiveRendererType.Percentage
    },
    rightAligned: false,
    defaultValueIfNull: '-'
  },
  percentage: {
    title: 'parties_table.percentage',
    responsive: 'xl',
    class: 'no-wrap',
    presentationComponent: BarChartRendererComponent,
  },
  percentage_diff: {
    title: 'parties_table.percentage_diff',
    responsive: 'xl',
    class: 'w-xl-15 no-wrap',
    presentationComponent: ResponsiveCompactRendererComponent,
    rendererOptions: new Map().set('showColors', true).set('asPercentage', true),
    rightAligned: true,
    defaultValueIfNull: '-'
  },
  id: { title: 'id', disable: true },
  listOrganisation: { title: '', disable: true },
  };

export const CandidateListColumnDef: WithPropsOfType<PartyOrCandidateListBase, ColumnMetadata> = {
  ...PartyColumnDef,
  title: {
    title: 'parties_table.candidatelist_title',
    path: "title",
    childPath: "name",
    class: 'w-50 w-xl-30',
    presentationComponent: ResponsiveBarChartRendererComponent,
    responsiveRenderer: {
      path: "percentage",
      breakpoint: "xl"
    },
  }
}

export interface PartyOrCandidateListBase extends TableDataItem {
  title: string;
  votes: number;
  diff?: number;
  percentage?: number;
  percentage_diff?: number;
  children?: PartyOrCandidateListDetail[];
  listOrganisation: ListOrganisation;
  hasSpecifiedPersonalVotes?: boolean;
}

export interface PartyOrCandidateListDetail extends TableDataItem {
  name: string;
  votes: number;
  diff?: number;
  percentage?: number;
  percentage_diff?: number;
}
